/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { IRetailerStoreLocations, IStoreLocation } from "types/store-location";

export const getNearbyRetailerLocations = (state: any): IStoreLocation[] => state.retailerLocations.nearbyStoreLocations;
export const getSelectedRetailerLocations = (state: any): IStoreLocation[] => state.retailerLocations.selectedStoreLocations;
